export * from '@primeuix/themes/lara/inplace';
export { default } from '@primeuix/themes/lara/inplace';
